/* Built In Imports */
import { useState } from 'react';
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Checkbox, Link, Modal, ModalBody, ModalContent,
    ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
/* Services */

/* Styles */

/**
 * Renders the About Container component
 *
 *
 * @returns {ReactElement} About Container component
 */
const Disclaimer = () => {
    const router = useRouter();
    const [checked, setChecked] = useState(false);
    let { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  return <>
    {router.asPath.indexOf(
          // '/yoga-meditation/yoga-program-for-beginners/hatha-yoga/courses-by-certified-teachers'
          `/redirect-to-site`
        ) > -1 && (
          <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={'2xl'}
            closeOnOverlayClick={false}
          >
            <ModalOverlay />
            <ModalContent bgColor="#ffffff">
              <ModalHeader
                paddingBottom="15px"
                fontFamily="FedraSansStd-A-medium"
              >
                <Box as="h4">Disclaimer</Box>
              </ModalHeader>
              {/* <ModalCloseButton /> */}
              <ModalBody
                fontFamily="FedraSansStd-medium"
                fontSize="16px"
                display="block"
                paddingTop="20px"
              >
                <Box
                  width="auto"
                  marginTop="0px"
                  height="150px"
                  overflowY="scroll"
                  color="#7a7a7a"
                  fontFamily="FedraSansStd-book"
                >
                  <Box as="p">
                  The independent yoga teachers displayed on isha.sadhguru.org are all yoga teachers certified by Isha Hatha School of Yoga. The information regarding independent Yoga teachers, as well as a link to their websites is only provided as a matter of convenience.
                  </Box>
                  <Box as="p" mt="10px">
                  We disclaim all warranties regarding the independent Yoga teacher’s website, information and services provided thereunder, express or implied, including without limitation, the warranties of merchantability, or fitness for a particular purpose.
                  </Box>
                  <Box as="p" mt="10px">
                  We make no warranties or representations, express or implied for all information, materials, products or services posted, offered or any link contained in a Third Party Website that may be accessed at the teachers’ websites linked to this site.
                  </Box>
                  <Box as="p" mt="10px">
                  If you use these links, and enter the independent Yoga teacher’s website you shall be governed by the Terms and Conditions & Privacy Policy of their website.
                  </Box>
                  <Box as="p" mt="10px">
                  We hereby disclaim all liability for any deficiency of services offered by the teachers at their website, including but not limited to any cancellation or postponement of programs listed in this site or any payment related issue in connection with the program.
                  </Box>
                </Box>
                <Box marginTop="20px">
                  <Box as="div" textAlign="left">
                    <Checkbox
                      isChecked={checked}
                      onChange={e => setChecked(!checked)}
                    >
                      I have completely read and understood the above Disclaimer
                      and I agree to be bound thereby.
                    </Checkbox>
                  </Box>
                  <Box as="div" marginTop="30px" textAlign="center">
                    {/* <NextLink href="#" passHref> */}
                    <Link
                      display="inline-block"
                      mb="20px"
                      fontFamily="FedraSansStd-medium"
                      borderRadius="3px"
                      bgColor="#cf4520"
                      color="rgb(250 247 240)"
                      fontSize="16px"
                      padding="10px 35px"
                      onClick={checked ? onClose : ''}
                      _hover={{
                        textDecoration: 'none',
                      }}
                    >
                      Continue
                    </Link>
                    {/* </NextLink> */}
                  </Box>
                </Box>
              </ModalBody>
            </ModalContent>
          </Modal>
        )}
  </>;
};

export default Disclaimer;
